import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, ArrowRight, LayoutGrid } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useDesktopLayout } from './DesktopNavigation';
import DesktopPageFrame from './DesktopPageFrame';
import { desktopRoute } from './desktopRoutes';
import './DesktopMorePages.css';
import './DesktopIslamicPages.css';

export default function DesktopRouteLayout({ children }) {
  const { pathname } = useLocation();
  const desktop = useDesktopLayout();
  const { language } = useLanguage();
  const { theme } = useTheme();
  const route = desktopRoute(pathname);
  if (!desktop || !route) return children;
  const ar = language === 'ar';
  const [kind, titleAr, titleEn, subtitleAr, subtitleEn] = route;
  const Arrow = ar ? ArrowLeft : ArrowRight;
  return <DesktopPageFrame activePath="/more" theme={theme} ar={ar} title={ar ? titleAr : titleEn} kicker={ar ? subtitleAr : subtitleEn} contentAs="div" className={`desktop-more-page desktop-route-${kind}`} actions={<Link className="desktop-secondary-action" to="/more"><LayoutGrid size={16} />{ar ? 'المزيد' : 'More'}<Arrow size={16} /></Link>}>
    <div className="desktop-route-content" key={pathname}>{children}</div>
  </DesktopPageFrame>;
}
